import {EVENT_BUS_CHAT_DELETED} from "../../model2/chat/chat/const";
import SessionEventProto from "../session-event-proto";

export default class SessionEvent_ChatRoomDelete extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        if (!gd.session.chatsLoaded) {
            // well no chats in session so ignore I guess ?
            // gd.session.chats = new ChatCollection(this.data,{parse:true});
        } else {
            const chat = gd.session.chats.get(this.data.id);
            gd.session.chats.remove(chat.id);
        }

        gd.bus.triggerEvent(EVENT_BUS_CHAT_DELETED, this.data);
        // gd.bus.triggerEvent('chat-room.{0}:delete'.f(this.data.id));

    }
};

